// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardExpandedStyles } from "@conklin/Overrides/Widgets/Cart/CartLineCardExpanded";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.productBrand = {
    nameLink: {
        css: css`
            align-self: flex-start;
            margin-bottom: 2px;
        `,
    },
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cartLineCardExpandedStyles.productInfoContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        @media print {
            margin-bottom: 8px;
        }
    `,
};
cartLineCardExpandedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardExpandedStyles.extendedUnitNetPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
cartLineCardExpandedStyles.invalidPriceHeadingAndText = {
    ...cartLineSharedStyles.invalidPriceHeadingAndText,
};

cartLineCardExpandedStyles.removeCartLineIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

cartLineCardExpandedStyles.addToListLink = cartLineSharedStyles.addToListLink;

cartLineCardExpandedStyles.configurationOptionText = {
    css: css`
        display: block;
    `,
};

cartLineCardExpandedStyles.deliveryScheduleButton = {
    css: css`
        margin-bottom: 10px;
    `,
};

cartLineCardExpandedStyles.configurationGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.costCodeText = {
    ...cartLineSharedStyles.costCodeValueText,
};

cartLineCardExpandedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

cartLineCardExpandedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};

cartLineCardExpandedStyles.costCodeSelect = {
    cssOverrides: {
        formField: css`
            width: 200px;
        `,
    },
};

cartLineCardExpandedStyles.cartLineErrorMessageGridItem = {
    width: 12,
    css: css`
        margin-top: 16px;
    `,
};

cartLineCardExpandedStyles.notesListWrapper = {
    css: css`
        position: relative;
        display: flex;
        gap: 32px;
    `,
};

cartLineCardExpandedStyles.quoteMessageWrapper = {
    ...cartLineSharedStyles.quoteMessage?.quoteMessageWrapper,
};

cartLineCardExpandedStyles.quoteTotal = {
    ...cartLineSharedStyles.quoteMessage?.quoteTotal,
};
cartLineCardExpandedStyles.quoteText = {
    ...cartLineSharedStyles.quoteMessage?.quoteText,
};

cartLineCardExpandedStyles.quoteTooltip = {
    ...cartLineSharedStyles.quoteMessage?.quoteTooltip,
};

cartLineCardExpandedStyles.quantity = {
    editableQuantityTextField: {
        qtyLabel: {
            css: css`
                display: none;
                ${xScreen("lte", "md")} {
                    display: block;
                }
            `,
        },
        editableQuantityTextField: {
            cssOverrides: {
                formInputWrapper: css`
                    @media print {
                        &&&& input {
                            text-align: left;
                            height: auto;
                        }
                    }
                `,
            },
        },
        wrapper: {
            css: css`
                &&& {
                    @media print {
                        height: auto;
                        width: auto;
                        min-width: auto;
                        border: none;
                    }
                }
            `,
        },
        container: {
            css: css`
                gap: 4px;
            `,
        },
    },
};

cartLineCardExpandedStyles.cartLineContainer = {
    container: {
        css: css`
            ${({ includeActions }: any) =>
                includeActions
                    ? "grid-template-columns: 91px minmax(45px,1fr) minmax(0,176px) minmax(0,129px) minmax(0,176px) minmax(34px, 38px);"
                    : "grid-template-columns: 91px minmax(45px,1fr) minmax(0,176px) minmax(0,129px) minmax(0,176px);"};

            ${xScreen("lte", "lg")} {
                ${({ includeActions }: any) =>
                    includeActions
                        ? "grid-template-columns: 91px minmax(45px,1fr) minmax(0,148px) minmax(0,108px) minmax(0,148px) minmax(34px, 38px);"
                        : "grid-template-columns: 91px minmax(45px,1fr) minmax(0,148px) minmax(0,108px) minmax(0,148px);"};
            }
        `,
    },
};
